import { Input } from 'antd';
import { useEffect, useRef, useState } from 'react';

/** 圖說是單行文字：自動換行顯示長圖說，但不允許手動換行。 */
const oneLine = (v: string) => v.replace(/\s*\n+\s*/g, ' ');

/**
 * 圖說輸入框（非受控於 node attrs）。
 * 每鍵都 updateAttributes 會觸發 ProseMirror transaction → NodeView 非同步重繪，
 * 把舊值寫回 textarea 打斷中文輸入法組字（注音被直接送出）。
 * 改為本地 state 驅動，組字中不寫回 node；組字結束／一般輸入／失焦時才提交。
 */
export default function CaptionInput({ value, onCommit }: { value: string; onCommit: (v: string) => void }) {
  const [draft, setDraft] = useState(value);
  const composing = useRef(false);
  const focused = useRef(false);

  // 外部變更（undo、換圖等）且非編輯中 → 同步回本地
  useEffect(() => {
    if (!focused.current) setDraft(value);
  }, [value]);

  const commit = (v: string) => {
    if (v !== value) onCommit(v);
  };

  return (
    <Input.TextArea
      variant="borderless"
      autoSize
      value={draft}
      placeholder="加入圖片說明（選填）…"
      onFocus={() => (focused.current = true)}
      onBlur={() => {
        focused.current = false;
        commit(draft);
      }}
      onCompositionStart={() => (composing.current = true)}
      onCompositionEnd={(e) => {
        composing.current = false;
        const v = oneLine(e.currentTarget.value);
        setDraft(v);
        commit(v);
      }}
      onChange={(e) => {
        const v = oneLine(e.target.value);
        setDraft(v);
        if (!composing.current) commit(v);
      }}
      onPressEnter={(e) => e.preventDefault()}
      className="!mt-1 !resize-none !text-center !text-base !text-gray-500 md:!text-sm"
    />
  );
}
